import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { lastValueFrom } from 'rxjs';

export enum RecaptchaAction {
  CheckGivexBalance = 'check_givex_balance',
  SubmitGuestPayment = 'submit_guest_payment',
  SubmitDelayedPaymentOrder = 'submit_delayed_payment_order'
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {
  constructor(private recaptchaV3Service: ReCaptchaV3Service) {}

  executeAction(action: RecaptchaAction): Promise<string> {
    return lastValueFrom(this.recaptchaV3Service.execute(action));
  }
}
